import React, { useRef, useState } from 'react'
import { AddImage, AddPost, AdminCloseIcon, BrandingEmoji, PostButtonIcon } from '../../../utils/icons';
import { checkImage, containsDefaultPng, fetchApi, getInitials } from '../../../utils/methods';
import { ImageUrl, imageErrorMessage } from '../../../utils/constants';
import { StyledModal, StyledBody, TopSectionV2, PostButton, PostButtonFeed, PostPopupTop, AddImageWrapper, UploadImage3, MaxImage } from '../../PhotoAndPostFlow/styles';
import { t } from 'i18next';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { InputTextAreaNew, UserInitialsMain } from '../../SocialFeedsV2/styles';
import SocialFeedsEmojiPicker from '../../SocialFeedsEmojiPicker';
import { CommonButtonBorder } from '../../common/commonStyles';
import { toast } from 'react-toastify';
import { PostEventMoment } from '../../../redux/constants/apiConstants';
import Spinner from '../../common/Spinner';

const ShareMoment = ({onClose,showModal, user,profileImage,event,getSharedMoments,companyId,getEventDetailsById,setSelectedMoment}) => {
  const inputRef = useRef();
  const[desc, setDesc]= useState("");
  const[displayEmoji, setDisplayEmoji] = useState(false);
  const [position, setPosition] = useState({ start: 0, end: 0 });
  const[images, setImages] = useState([]);
  const[loading, setLoading]=useState(false)


  const addNewMoment = async()=>{
    setLoading(true);
    const payload = {event_id:event.id,images,text:desc};
    try{
      const res = await fetchApi(PostEventMoment, "POST",payload);
      if(res.status === "success"){
        // setWellnessChallengeList(res.data);
        setSelectedMoment({id:res?.data?.moment_id})
        getEventDetailsById(event.id)
        toast.success(res?.message);
        setLoading(false);
        onClose(true);
        getSharedMoments(companyId,1)
        
      }else{
        toast.error(res.message);
        setLoading(false);
      }
    }catch(error){
      toast.error(error);
      setLoading(false);
    }

  }

  const removeBoldTag=(input)=> {
    const regex = input.replace(/<b>/, "").replace(/<\/b>/, "").replace(/>/gi, "").replace(/<b/gi, "")
    return(regex)
  }

  const onEmojiSelect = (emoji, id, native, skin) => {
    window.console.log("hii",emoji, id,skin)
    addInspirationV2(native);
  };

  const getPosition = (el) => {
    let start = 0,
      end = 0,
      normalizedValue,
      range,
      textInputRange,
      len,
      endRange;

    if (
      typeof el.selectionStart == "number" &&
      typeof el.selectionEnd == "number"
    ) {
      start = el.selectionStart;
      end = el.selectionEnd;
    } else {
      range = document.selection.createRange();

      if (range && range.parentElement() == el) {
        len = el.value.length;
        normalizedValue = el.value.replace(/\r\n/g, "\n");
        textInputRange = el.createTextRange();
        textInputRange.moveToBookmark(range.getBookmark());
        endRange = el.createTextRange();
        endRange.collapse(false);

        if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
          start = end = len;
        } else {
          start = -textInputRange.moveStart("character", -len);
          start += normalizedValue.slice(0, start).split("\n").length - 1;

          if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
            end = len;
          } else {
            end = -textInputRange.moveEnd("character", -len);
            end += normalizedValue.slice(0, end).split("\n").length - 1;
          }
        }
      }
    }

    return {
      start: start,
      end: end,
    };
  };

  const addInspirationV2 = (e) => {
    // Create the new description with the added text
    const newText =
      desc.slice(0, position.start) +
      e +
      desc.slice(position.end);

    // Update the position and desc state
    setPosition((prevPosition) => ({
      start: prevPosition.start + e.length,
      end: prevPosition.end + e.length,
    }));
    setDesc(newText);
  };

  const onChangeImage = async (e) => {
    const files = Array.from(e.target.files);
    const validFiles = [];
  
    for (const file of files) {
      if (!checkImage([file])) {
        toast.error(imageErrorMessage);
        continue;
      }
      if (file.size / 1000000 > 20) {
        toast.error("Please select image file less than 20MB");
        continue;
      }
  
      const reader = new FileReader();
      const dataUrl = await new window.Promise((resolve) => {
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
  
      validFiles.push(dataUrl);
    }
  
    if (validFiles.length) setImages((prev) => [...prev, ...validFiles]);
    e.target.value = "";
  };
  

  const removeImage = (src,index) => {
    // let arrayy = this.state.imgSrcArray.filter((item) => item !== src)
    let arrayy = images.filter((item,i) => i !== index);
    setImages(arrayy)
  }

  const renderImages = () => (
    // window.console.log("imgSrcArray", images),
    images?.map((src, index) => (
      (
        <div className='imageDiv' key={index}>
          <img alt='img' width='144px' height='144px' src={src} />
          <span className='remove' onClick={() => removeImage(src,index)} style={{background:"white", borderRadius:"2px", height:"20px", width:"20px", justifyContent:"center", alignItems:"center", display:"flex"}}>
            <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>{AdminCloseIcon()}</div>
          </span>
        </div>
      )
    )))



  const textArea = ()=>(
    <>
      <InputTextAreaNew
      //   onKeyDown={this.handleKey}
      //   isCommentOrReply={isCommentOrReply}
      //   padding={placeholder.includes('reply') ? '13px' : '0'}
      //   width={placeholder.includes('reply') ? '80%' : '100%'}
      >
        <textarea
        //   style={{  minHeight: '200px' }}
          placeholder={'Write your thoughts and upload images here'}
          rows="1" // Start with a single row
          name=""
          onChange={(e) => {
            setDesc(e.target.value);
            const position = getPosition(e.target);
            setPosition(position);
            //   this.props.addInspiration(e);
            // Adjust the height based on content
            e.target.style.height = 'auto'; // Reset height
            e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight
          }}
          //   onClick={(e) => this.props.addInspiration(e)}
          value={removeBoldTag(desc)}
          data-gramm_editor="false"
          className={'CustomTextAreaField'}
          //   onScroll={onScroll}
          spellCheck="false"
          ref={inputRef}
          id="inpu"
          maxLength={'300'}
        >
          {desc}
        </textarea>
      </InputTextAreaNew>
      {displayEmoji ? <SocialFeedsEmojiPicker selectEmoji={onEmojiSelect} emojiRef={inputRef} hidePicker={()=>setDisplayEmoji(false)}></SocialFeedsEmojiPicker> : null}
    </>
  )
    
  return (
    <>
      <StyledModal show={showModal} onHide={()=>{onClose();}} width="800px">
        <PostPopupTop>
          <div className='heading'>{t("Share Your Moment")}</div>
          <div className='closeIcon' onClick={()=>{onClose();}}>{AdminCloseIcon()}</div>
        </PostPopupTop>
        <div style={{height:"1px", width:"100%", background:"#EFEFEF", margin:"0"}}/>
        <StyledBody>
          <TopSectionV2 
            //   disable={} 
            background maxHeight="320px" margin="16px 0">
            <div className='user-details'>
              <div className='profile'>
                {!containsDefaultPng(profileImage)?
                  <img src={ImageUrl + "/" +profileImage}/>:
                  <UserInitialsMain font>{`${getInitials(user?.fname)}${getInitials(user?.lname)}`}</UserInitialsMain>}
              </div>
              <div className='privacy-admin'>
                <div className='name'>{user.fname} {user.lname}</div>
              </div>
            </div>
            {textArea()}
            
            <PostButton>
              <div className='btn-container'>
                <div className='emojiIcon' 
                  onClick={()=>setDisplayEmoji(true)}
                >     
                  {BrandingEmoji()}
                </div>
                {images.length === 0 ? <CommonButtonBorder 
                //   onClick={()=>setDisplayEmoji(true)}
                  height={'32px'}
                  width={'auto'}
                  margin={'0px 0px 0px 12px'}
                >     
                  {AddPost()} Upload Image

                  <input
                    id="upload-file"
                    type="file"
                    name="user"
                    multiple={true}
                    onChange={(e) => onChangeImage(e)}
                    accept=".jpeg, .png, .jpg"
                    hidden
                    className='input'
                  />
                </CommonButtonBorder>:null}
              </div>
              <div className='char-count'>
                {desc.length}/300 | C
              </div>
            </PostButton>

            {images.length ?<> <AddImageWrapper>
              {renderImages()}
              {
                images?.length < 10 && 
                  <UploadImage3>
                    {AddImage()}
                    <input
                      id="upload-file"
                      type="file"
                      name="user"
                      multiple={true}
                      onChange={(e) => onChangeImage(e)}
                      accept=".jpeg, .png, .jpg"
                      hidden
                    />
                  </UploadImage3>
              }
            </AddImageWrapper>
            <MaxImage margin={"4px 0px"}>You can upload up to 10 images</MaxImage></>: null}
            {/* <div style={{height:"1px", width:"100%", background:"#EFEFEF", margin:"0 0 16px 0"}}/> */}
            <PostButtonFeed disable={!images.length || !desc || loading || images.length > 10} margin={'16px 0px'}>
              <div className='button' 
                onClick ={()=>images.length && desc && !loading && images.length <= 10 && addNewMoment()}
              >
                {loading ? <Spinner color={"#F37A65"}/> : 'Post'}
                <span/>
                {!loading && PostButtonIcon(!user || !images.length || !desc || loading || images.length > 10  ? "#BDBDBD":"#F8F8F8")}
              </div>
            </PostButtonFeed>
          </TopSectionV2>
        </StyledBody>
      </StyledModal>
    </>
  )
}

ShareMoment.propTypes = {
  onClose: PropTypes.func,
  showModal:PropTypes.bool,
  user:PropTypes.object,
  profileImage:PropTypes.string,
  event:PropTypes.object,
  getSharedMoments:PropTypes.func,
  companyId:PropTypes.string,
  page:PropTypes.number,
  getEventDetailsById:PropTypes.func,
  setSelectedMoment:PropTypes.func
}

const mapStateToProps = (state) => ({
  user: state.profileData.user,
  profileImage: state.profileData.profileImage,
});

export default connect(mapStateToProps, null)(withTranslation()(ShareMoment));